import $lodash from 'lodash'

const types = {
  SET_OPTION_DATA: 'directCalculation/SET_OPTION_DATA',
  SET_SELECTED_DATA: 'directCalculation/SET_SELECTED_DATA',
  UPDATE_SELECTED_DATA: 'directCalculation/UPDATE_SELECTED_DATA',
  RESET_SELECTED_DATA: 'directCalculation/RESET_SELECTED_DATA',
  UPDATE_REQUIRE_CHECK_DATA: 'directCalculation/UPDATE_REQUIRE_CHECK_DATA',
  SET_MEDIA_FORMAT_BUDGET: 'directCalculation/SET_MEDIA_FORMAT_BUDGET',
  REMOVE_MEDIA_FORMAT_BUDGET: 'directCalculation/REMOVE_MEDIA_FORMAT_BUDGET',
  REMOVE_SELECTED_MEDIA: 'directCalculation/REMOVE_SELECTED_MEDIA',
  CLONE_SELECTED_DATA: 'directCalculation/CLONE_SELECTED_DATA',
  UPDATE_CALCULATION_RESULT: 'directCalculation/UPDATE_DIRECT_CALCULATION_RESULT'
}

// 預設的空選擇資料
const defaultSelectedData = () => {
  return {
    adFormatBudget: [],
    adFormatHash: [],
    flvSecond: 30,
    playDate: [],
    media: {
      isPrime: 1,
      includeIds: [],
      excludeIds: []
    },
    condition: {
      // direct 固定帶給後端的資料
      placement_type_id: 1
    }
  }
}

// 選項必填檢查
const defaultRequireCheckList = () => {
  return {
    flvSecond: false,
    playDate: false,
    media: false
  }
}
const defaultOptions = () => {
  return {
    flv_second: [],
    medias: {
      categories: []
    }
  }
}
const state = {
  options: defaultOptions(),
  selectedData: defaultSelectedData(),
  calculationResult: null,
  requireCheckList: defaultRequireCheckList(),
  adFormatTypeAndBudgets: [],
  // 儲存條件用
  favoriteSelectedData: []
}
const defaultSelectedMedia = () => {
  return [
    {
      description: [],
      ad_types: []
    }
  ]
}
const getters = {
  // 檢查所有選項是否都通過必填檢驗
  requireAllPass: (state, getters, rootState) => {
    return Object.values(state.requireCheckList).every(warningText => !warningText) &&
          rootState.root.baseInfoChecked &&
          (getters.totalBudgetSum.mobile !== 0 || getters.totalBudgetSum.desktop !== 0)
  },
  allMedias: state => state.options.medias.categories.map(category => category.media).flat(),
  selectedMediaAdFormats: (state, getters) => {
    if (state.selectedData.media.includeIds.length > 0) {
      return getters.allMedias.filter(media => state.selectedData.media.includeIds.includes(media.uid)) || defaultSelectedMedia()
    } else {
      return []
    }
  },
  mediaBudgetSum: (state) => {
    if (state.adFormatTypeAndBudgets === []) return []
    let groupByMediaUid = $lodash.groupBy(state.adFormatTypeAndBudgets, 'uid')
    for (var key in groupByMediaUid) {
      let returnValue = { mobile: 0, desktop: 0, totalSum: null, uid: null, price: null, adFormatTypeId: null }
      groupByMediaUid[key].forEach(item => {
        // @FIXME: 這樣分類可能會有問題
        // 'M' 開頭歸類是 mobile, 其他是 Desktop
        if (item.adFormat[0].toUpperCase() === 'M') {
          returnValue.mobile += parseInt(item.budget)
        } else {
          returnValue.desktop += parseInt(item.budget)
        }
        returnValue.totalSum = returnValue.mobile + returnValue.desktop
        returnValue.price = item.price
        returnValue.media = item.media
      })
      groupByMediaUid[key] = returnValue
    }
    return groupByMediaUid
  },
  totalBudgetSum: (state, getters) => {
    let mediaBudgetSum = $lodash.cloneDeep(getters.mediaBudgetSum)
    if (mediaBudgetSum === []) return { mobile: 0, desktop: 0 }
    let mobileBudgetSum = Object.keys(mediaBudgetSum).reduce((sum, mediaUid) => {
      return sum + mediaBudgetSum[mediaUid].mobile
    }, 0)
    let desktopBudgetSum = Object.keys(mediaBudgetSum).reduce((sum, mediaUid) => {
      return sum + mediaBudgetSum[mediaUid].desktop
    }, 0)
    return { mobile: mobileBudgetSum, desktop: desktopBudgetSum }
  },
  favoriteSelectedData: (state) => {
    let clonedSelected = $lodash.cloneDeep(state.selectedData)
    clonedSelected.adFormatBudget = state.adFormatTypeAndBudgets
    return clonedSelected
  }
}
const actions = {
  // 設定選項
  setOptions ({ commit }, data) {
    commit(types.SET_OPTION_DATA, data)
  },
  // LOAD FAVORITE DATA AND THEN USE IT
  setSelectedData ({ commit }, data) {
    commit(types.SET_SELECTED_DATA, data)
  },
  // 更新選擇資料
  updateSelectedData ({ commit }, data) {
    commit(types.UPDATE_SELECTED_DATA, data)
  },
  // 清空選擇資料
  // 但如果是 agency 或 client，要再設定代理商名或是客戶名
  resetSelectedData ({ commit, dispatch }) {
    commit(types.RESET_SELECTED_DATA)
    dispatch('root/resetSelectedData', null, { root: true })
  },
  // 更新欄位檢查狀態
  updateRequireCheckData ({ commit }, data) {
    commit(types.UPDATE_REQUIRE_CHECK_DATA, data)
  },
  setAdFormatAndBudget ({ commit }, data) {
    commit(types.SET_MEDIA_FORMAT_BUDGET, data)
  },
  removeSelectedMedia ({ commit }, data) {
    commit(types.REMOVE_SELECTED_MEDIA, data)
    commit(types.REMOVE_MEDIA_FORMAT_BUDGET, data)
  },
  cloneSelectedData ({ commit }, data) {
    commit(types.CLONE_SELECTED_DATA, data)
  },
  updateCalculationResult ({ commit }, data) {
    commit(types.UPDATE_CALCULATION_RESULT, data)
  }
}

const mutations = {
  [types.SET_OPTION_DATA] (state, data) {
    Object.assign(state.options, data)
  },
  [types.SET_SELECTED_DATA] (state, data) {
    state.selectedData = data
  },
  [types.UPDATE_SELECTED_DATA] (state, data) {
    const cloneData = $lodash.cloneDeep(data)
    cloneData.forEach(item => {
      $lodash.set(state.selectedData, item.key, item.value)
    })
  },
  [types.CLONE_SELECTED_DATA] (state, data) {
    state.selectedData = $lodash.cloneDeep(data)
  },
  [types.RESET_SELECTED_DATA] (state) {
    state.selectedData = defaultSelectedData()
  },
  [types.UPDATE_REQUIRE_CHECK_DATA] (state, data) {
    const cloneData = $lodash.cloneDeep(data)
    state.requireCheckList[cloneData.key] = cloneData.value
  },
  [types.SET_MEDIA_FORMAT_BUDGET] (state, data) {
    // https://stackoverflow.com/questions/38365075/vuex-vuejs-do-not-mutate-vuex-store-state-outside-mutation-handlers/56884483#56884483
    // 不 clone 的話，因為 array 給值是 pass by reference, 直接 state.adFormatTypeAndBudgets = data 會噴 不能在 mutation 外修改 state 的錯誤
    let clonedDate = $lodash.cloneDeep(data)
    state.adFormatTypeAndBudgets = clonedDate
  },
  [types.REMOVE_SELECTED_MEDIA] (state, data) {
    let uid = data
    state.selectedData.media.includeIds = state.selectedData.media.includeIds.filter(mediaUid => mediaUid !== uid)
  },
  [types.REMOVE_MEDIA_FORMAT_BUDGET] (state, data) {
    let uid = data
    state.adFormatTypeAndBudgets = state.adFormatTypeAndBudgets.filter(item => item.uid !== uid)
  },
  [types.UPDATE_CALCULATION_RESULT] (state, data) {
    state.calculationResult = $lodash.cloneDeep(data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
